import Vue from "vue";
import FeatureRepository from "@/repositories/FeatureRepository";
import _ from "lodash";

export interface Feature {
    uuid: string;
    code: string;
    description: string|null;
    parent: Feature|null;
}

export default {
    state: {
        features: [],
    },
    mutations: {
        setFeatures: (state: any, features: Feature[]) => {
            Vue.set(state, "features", features);
        },
    },
    getters: {
        getAllFeatures: (state: any): Feature[] => {
            return state.features;
        },
        getFeatures: (state: any) => (parentUuid: string | null): Feature[] => {
            return _.filter(state.features, (feature: Feature) => {
                return _.get(feature, "parent.uuid", null) === parentUuid;
            });
        },
    },
    actions: {
        loadFeatures: ({ commit }: any) => {
            return new Promise((resolve: (value: object) => void, reject: (value: object) => void) => {
                FeatureRepository.get().then((data: any) => {
                    commit("setFeatures", data);
                    resolve(data);
                }).catch((reason: any) => {
                    reject(reason);
                });
            });
        },
    },
};
